/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchManufacturersResponse } from './search-manufacturers-response';


export interface SearchManufacturersResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchManufacturersResponse> | null;
}

